import React from 'react';

/* Emoji Picker */
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

const EmojiPicker = ({ showEmojiPicker, setShowEmojiPicker, onEmojiSelect }) => {

    const handleEmojiSelect = (emoji) => {
        if (onEmojiSelect) {
            onEmojiSelect(emoji);
        }
        setShowEmojiPicker(false);
    };

    return (
        <>
            {showEmojiPicker && (
                <>
                    <div
                        style={{
                            position: 'absolute',
                            top: '10px',
                            left: '4rem',
                            zIndex: 99999999,
                            border: '1px solid #E4E4E4',
                            borderRadius: '5px',
                            background: '#fff',
                        }}
                    >
                        {/* Close button */}
                        <div style={{ textAlign: 'right', padding: '4px' }}>
                            <button
                                onClick={() => setShowEmojiPicker(false)}
                                style={{
                                    border: 'none',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                }}
                            >
                                ✕
                            </button>
                        </div>

                        <Picker
                            data={data}
                            maxFrequentRows={0}
                            previewPosition="none"
                            emojiButtonSize={36}
                            onEmojiSelect={handleEmojiSelect}
                        />
                    </div>
                </>
            )}
        </>
    );
}

export default EmojiPicker;
